import { Table as PrimitiveTable } from '@tiptap/extension-table'
import { TableCell } from '@tiptap/extension-table-cell'
import { TableHeader } from '@tiptap/extension-table-header'
import { TableRow } from '@tiptap/extension-table-row'

export const Table = PrimitiveTable.extend({
  addExtensions() {
    return [TableRow, TableHeader, TableCell]
  },
})
